<form class="forms-sample" #ngUploadEmployeeForm="ngForm" name="form">
  <!-- Contract Selection -->
  <div class="row">
    <div class="col">
      <div class="form-group">
        <label for="contract"></label>
        <ng-select
          [(ngModel)]="contract"
          name="contract"
          #Erequest="ngModel"
          (change)="onContractChange($event)"
        >
          <ng-option value="">--Select Request--</ng-option>
          <ng-option *ngFor="let request of Contracts" [value]="request">
            {{ request.reference }}
          </ng-option>
        </ng-select>
        <p *ngIf="ngUploadEmployeeForm.submitted && Erequest.errors" style="color: red;">
          Please select associated request form
        </p>
      </div>
    </div>

    <!-- Mode Toggle -->
    <div class="col" *ngIf="contract && canUploadEmployee">
      <div class="form-group">
        <label><b>Mode:</b></label>
        <div>
          <label class="mr-3">
            <input type="radio" name="mode" [(ngModel)]="formMode" value="multiple" /> Upload Multiple
          </label>
          <label>
            <input type="radio" name="mode" [(ngModel)]="formMode" value="single" /> Add Single
          </label>
        </div>
      </div>
    </div>
  </div>

  <!-- Upload Multiple Employees -->
  <div class="row" *ngIf="contract && formMode === 'multiple' && canUploadEmployee">
    <div class="col">
      <div class="form-group">
        <label for="">Excel File</label>
        <input class="form-control" type="file" (change)="onChange($event)" />
      </div>
      <h5><b><a href="assets/EmpTemplate.xlsx" download>Download Excel Template</a></b></h5>
    </div>
  </div>

  <nz-alert
    *ngIf="showPendingError"
    nzType="error"
    nzMessage="Upload not Allowed"
    nzDescription="Selected Request has a pending uploaded file waiting for approval"
  ></nz-alert>

  <!-- Add Single Employee -->
   <form #employeeForm="ngForm">
      <div *ngIf="contract && formMode === 'single'">
        <div class="row">
          <div class="col">
            <div class="form-group">
              <label>Surname</label>
              <input class="form-control" [(ngModel)]="singleEmployee.surname" name="surname" required />
            </div>
          </div>
          <div class="col">
            <div class="form-group">
              <label>Other Names</label>
              <input class="form-control" [(ngModel)]="singleEmployee.otherNames" name="otherNames" required />
            </div>
          </div>
          <div class="col">
            <div class="form-group">
              <label>Email</label>
              <input class="form-control" [(ngModel)]="singleEmployee.email" name="email" type="email" />
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col">
            <div class="form-group">
              <label>Phone Number</label>
              <input class="form-control" [(ngModel)]="singleEmployee.phoneNumber" type="tel" pattern="/d*" inputmode="numeric" maxlength="11" name="phoneNumber" />
            </div>
          </div>
          <div class="col">
            <div class="form-group">
              <label>Gender</label>
              <select class="form-control" [(ngModel)]="singleEmployee.gender" name="gender">
                <option value="">Select</option>
                <option value="Male">Male</option>
                <option value="Female">Female</option>
              </select>
            </div>
          </div>
          <div class="col">
            <div class="form-group">
              <label>DOB</label>
              <input class="form-control" type="date" [(ngModel)]="singleEmployee.dateOfBirth" name="dateOfBirth" />
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col">
            <div class="form-group">
              <label>Labour Rate</label>
              <input class="form-control" type="number" [(ngModel)]="singleEmployee.labourRate" name="labourRate" />
            </div>
          </div>
          <div class="col">
            <div class="form-group">
              <label>Start Date</label>
              <input class="form-control" type="date" [(ngModel)]="singleEmployee.startDate" name="startDate" />
            </div>
          </div>
          <div class="col">
            <div class="form-group">
              <label>End Date</label>
              <input class="form-control" type="date" [(ngModel)]="singleEmployee.endDate" name="endDate" />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <div class="form-group">
              <label>Address</label>
              <input class="form-control" type="text" [(ngModel)]="singleEmployee.address" name="address" />
            </div>
          </div>
          <div class="col">
            <div class="form-group">
              <label>Qualification </label>
              <input class="form-control" type="text" [(ngModel)]="singleEmployee.qualification" name="qualification" />
            </div>
          </div>
          <div class="col">
            <div class="form-group">
              <label>Position</label>
              <input class="form-control" type="text" [(ngModel)]="singleEmployee.position" name="position" />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <div class="form-group">
              <label>Description</label>
              <input class="form-control" type="text" [(ngModel)]="singleEmployee.desciption" name="desciption" />
            </div>
          </div>
          <div class="col">
            <div class="form-group">
              <label>Last Work Place </label>
              <input class="form-control" type="text" [(ngModel)]="singleEmployee.lastPlaceOfWork" name="lastPlaceOfWork" />
            </div>
          </div>
          <div class="col">
            <div class="form-group">
              <label>Work Location</label>
              <input class="form-control" type="text" [(ngModel)]="singleEmployee.workLocation" name="workLocation" />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <div class="form-group">
              <label>Next-Of-Kin</label>
              <input class="form-control" type="text" [(ngModel)]="singleEmployee.nextOfKin" name="nextOfKin" />
            </div>
          </div>
          <div class="col">
            <div class="form-group">
              <label>Next-Of-Kin Phone </label>
              <input class="form-control" type="text" [(ngModel)]="singleEmployee.nextOfKinPhone" type="tel" pattern="/d*" inputmode="numeric" maxlength="11" name="nextOfKinPhone" />
            </div>
          </div>
          <div class="col">
            <div class="form-group">
              <label>Next-Of-Kin Address</label>
              <input class="form-control" type="text" [(ngModel)]="singleEmployee.nextOfKinAddress" name="nextOfKinAddress" />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <div class="form-group">
              <label>Head Count Classification </label>
              <select class="form-control" required [(ngModel)]="singleEmployee.headCountClassification" name="headCountClassification"
                id="modeOfHeadCount">
                <option value="">-- Select Classification --</option>
                <option [value]="mode.option" *ngFor="let mode of headCountClassDropdown">{{mode.option}}
                </option>
              </select>
            </div>
          </div>
          <div class="col" *ngIf="contract?.type !='ADHOC'">
            <div class="form-group" > 
              <label>Axiom </label>
              <!-- <input class="form-control" type="text" [(ngModel)]="singleEmployee.axiom" name="axiom" /> -->
              <select class="form-control"  [required]="isAxiomRequired()" [(ngModel)]="singleEmployee.axiom" name="axiom"
                        id="axiom" >
                        <option value="">-- Select Axiom --</option>
                        <option [value]="axiom.name" *ngFor="let axiom of axioms">{{axiom.name}}
                        </option>
                      </select>
            </div>
          </div>
          <div class="col">
            <div class="form-group">
              <label>Mode Of Head Count</label>
              <!-- <input class="form-control" type="text" [(ngModel)]="singleEmployee.modeOfHeadCount" name="modeOfHeadCount" /> -->
              <select class="form-control" required [(ngModel)]="singleEmployee.modeOfHeadCount" name="modeOfHeadCount"
                id="modeOfHeadCount">
                <option value="">-- Select Mode --</option>
                <option [value]="mode.option" *ngFor="let mode of modeOfHeadCountDropdown">{{mode.option}}
                </option>
              </select>
            </div>
          </div>
        </div>

        <!-- Add more fields here as needed from the payload -->
      </div>
    </form>
</form>

<!-- File Upload Preview -->
<div class="card-title" *ngIf="fileDetailData && formMode === 'multiple'">
  <h4 class="card-title">File Content</h4>
</div>
<div *ngIf="fileDetailData && formMode === 'multiple'">
  <h6>Number of records: {{ counter }}</h6>
</div>

<nz-table
  #fileContent
  [nzData]="fileDetailData"
  [nzPageSize]="10"
  *ngIf="fileDetailData && formMode === 'multiple'"
>
  <thead>
    <tr>
      <th>S/N</th>
      <th>Surname</th>
      <th>Other Names</th>
      <th>Phone Number</th>
      <th>Email</th>
      <th>Gender</th>
      

      <th>Labour Rate</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let data of fileContent.data; let i = index">
      <td>{{ i + 1 }}</td>
      <td>{{ data.Surname }}</td>
      <td>{{ data.OtherNames }}</td>
      <td>{{ data.PhoneNumber }}</td>
      <td>{{ data.Email }}</td>
      <td>{{ data.Gender }}</td>
      

      <td>{{ data.LabourRate }}</td>
    </tr>
  </tbody>
</nz-table>

<!-- Request Summary -->
<div class="card" *ngIf="contract?.type">
  <div class="card-body">
    <div class="card-title">
      <h4 class="card-title">Request Summary</h4>
    </div>

    <div class="row">
      <div class="col" *ngFor="let field of [
        { label: 'Request Reference', value: contract?.reference },
        { label: 'Function', value: contract?.departmentName },
        { label: 'Location', value: contract?.locationName },
        { label: 'Cost Center', value: contract?.costCenterName },
        { label: 'Request Date', value: contract?.createdDate | date: 'dd MMMM yyyy' },
        { label: 'Contract Duration ', value: contract?.contractDuration },
        { label: 'Expected Start Date', value: contract?.expectedStartDate | date: 'dd MMMM yyyy' },
        { label: 'Approved No of Staff', value: contract?.noOfStaff },
        { label: 'Approved Cost', value: contract?.approvedCost },
        { label: 'Requested By', value: contract?.createdBy },
        { label: 'Contractor', value: contract?.contractorName },
        { label: 'PO Number', value: contract?.poNumber },
        { label: 'Request Description', value: contract?.description },
        { label: 'Request Justification', value: contract?.justification },
        { label: 'Required Qualification & Experience', value: contract?.qualification },
        { label: 'Active Number of Employees', value: contract?.activeNumberOfEmployees }
      ]">
        <div class="form-group">
          <label><b>{{ field.label }}</b></label>
          <p>{{ field.value }}</p>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Buttons -->
<div class="mt-3" *ngIf="canUploadEmployee" >
  <button
    *ngIf="contract && formMode === 'multiple' && !showPendingError"
    (click)="onUpload()"
    class="btn btn-primary"
    [disabled]="uploadDisabled"
  >
    Upload Excel
  </button>

  <button
    *ngIf="contract && formMode === 'single'"
    (click)="onCreateSingleEmployee(employeeForm)"
    class="btn btn-success"
  >
    Create Employee
  </button>
</div>
